import { ICache, Cacheable, CACHE_KEY_PREFIX } from './shared';

/** @hidden */

export class SessionStorageCache implements ICache {
  public set<T = Cacheable>(key: string, entry: T) {
    sessionStorage.setItem(key, JSON.stringify(entry));
  }

  public get<T = Cacheable>(key: string) {
    const json = window.sessionStorage.getItem(key);

    if (!json) return;

    try {
      const payload = JSON.parse(json) as T;
      return payload;
    } catch (e) {
      /* istanbul ignore next */
      return;
    }
  }

  public remove(key: string) {
    sessionStorage.removeItem(key);
  }

  public allKeys() {
    return Object.keys(window.sessionStorage).filter(key =>
      key.startsWith(CACHE_KEY_PREFIX)
    );
  }
}
